import { getAlertMessage } from 'Alerts/AlertMessages';
import AlertPopup from 'Alerts/AlertPopup';
import ErrorTooltip from 'Components/ErrorTooltip';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import env from 'environment_system/env_system';
import { Field, FieldProps, useFormikContext } from 'formik';
import { handleNoSpaceInputChange, saveEditForm } from 'GenericForms/Helper';
import { RootState } from 'index';
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Button, CardBody, CardFooter, Col, Form, Input, Label, Row } from 'reactstrap';
import { customStyle } from 'shared/CommonCSS';
import { AlertColourTypeConstant, AlertTypeConstant } from 'shared/constants';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface WeatherDataStructureTypes {
  refreshKey: number;
  toggleTab: any;
  alertBool: boolean;
  setAlertBool: (value: boolean) => void;
  setAlertColourType: (value: string) => void;
  setAlertType: (value: string) => void;
  alertMessage: string;
  setAlertMessage: (value: string) => void;
  fieldId: string;
  setFieldId: (value: string) => void;
  fieldVisibility: any;
  setErrorMessage: any;
  setRefreshKey: any;
  AddGeneralAvgSpeed: boolean;
  directionOptions: any;
  calculateSeaForce: any;
  calculateBeaufortScale: any;
  alertType: string;
  alertColourType: string;
  setEditValues?: any;
  editValues?: any;
  editInitalValues?: any;
  editSubmit?: any;
  editIsSubmitting?: any;
  fieldValue?: any;
  setAlertFieldValue?: any;
  fieldLable?: any;
  setAlertFieldLabel?: any;
}

const WeatherDataStructure = ({
  fieldVisibility,
  setEditValues,
  alertColourType,
  alertType,
  setErrorMessage,
  setRefreshKey,
  AddGeneralAvgSpeed,
  directionOptions,
  calculateSeaForce,
  toggleTab,
  alertBool,
  setAlertBool,
  setAlertColourType,
  setAlertType,
  alertMessage,
  setAlertMessage,
  fieldId,
  setFieldId,
  refreshKey,
  calculateBeaufortScale,
  editInitalValues,
  editSubmit,
  editIsSubmitting,
  fieldLable,
  setAlertFieldLabel,
  fieldValue,
  setAlertFieldValue,
}
  : WeatherDataStructureTypes
) => {
  /** State variables */
  const { setPreviousDeckTabIndex, setDeckActiveTabBool, activeEditTab, toggle, editReportBool, discardwarning } = useEditReport();
  const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
  const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    isSubmitting,
    initialValues,
    handleSubmit,
    validateForm,
    setFieldTouched,
    setErrors,
  }: {
    values: any,
    errors: any,
    touched: any,
    handleChange: any,
    handleBlur: any,
    setFieldValue: any,
    isSubmitting: any,
    resetForm: any,
    initialValues: any,
    handleSubmit: any,
    validateForm: any,
    setFieldTouched: any,
    setErrors: any,
  } = useFormikContext<any>();
  /** State variables end */

  /** useEffect */
  useEffect(() => {
    if (editInitalValues && editInitalValues?.deck_officer?.weather_data?.id > 0) {
      setEditValues({
        ...editInitalValues,
        deck_officer: {
          ...editInitalValues?.deck_officer,
          weather_data: values?.weather_data
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.weather_data])
  /** useEffect end */

  return (
    <Form onSubmit={handleSubmit} autoComplete="off" noValidate key={refreshKey}>
      <CardBody className="mt-2 deck-card-body">
        <Row>
          {fieldVisibility.steamingTime.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="steaming_time">
                  Steaming time
                </Label>
                <i className="bx bx-info-circle ml-2p" id="steaming_time_msg" />
                <ToolTip
                  target="steaming_time_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "steaming_time_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field
                    type="text"
                    className="form-control text-right max-width-7 cursor-not-allowed"
                    id="weather_data.steaming_time"
                    name="weather_data.steaming_time"
                    disabled
                  />
                  <div className="input-group-text round_border">min</div>
                </div>
              </Col>
            )}
          {fieldVisibility.avgGroundSpeed.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col md={3}>
                <Label className="mb-0" for="avg_ground_speed">
                  Avg. ground speed
                </Label>
                <div className="mb-2 input-group">
                  <Field
                    type="text"
                    className="form-control disabled text-right max-width-7 cursor-not-allowed"
                    id="weather_data.avg_ground_speed"
                    name="weather_data.avg_ground_speed"
                    disabled
                  />
                  <div className="input-group-text round_border">
                    knots
                  </div>
                </div>
              </Col>
            )}
          {fieldVisibility.avgWaterSpeed.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col md={3}>
                <Label className="asteric mb-0" for="weather_data_avg_water_speed">
                  Avg. water speed
                </Label>
                <div className="mb-2 input-group">
                  <Field
                    type="text"
                    className="form-control disabled text-right max-width-7"
                    id="weather_data_avg_water_speed"
                    name="weather_data.avg_water_speed"
                    autoFocus={fieldVisibility.avgWaterSpeed.includes(
                      currentVesselReport && currentVesselReport?.reporting_event
                    ) ? true : false}
                  />
                  <div className="input-group-text round_border">knots</div>
                </div>
                {errors &&
                  errors?.weather_data?.avg_water_speed &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_avg_water_speed"
                      message={errors.weather_data.avg_water_speed}
                      open={!!errors.weather_data.avg_water_speed}
                    />
                  )}
              </Col>

            )}
          {fieldVisibility.windDirection.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col md={3}>
                <Label className="asteric mb-0" for="weather_data_wind_direction">
                  Wind direction
                </Label>
                <i className="bx bx-info-circle ml-2p" id="wind_direction_msg" />
                <ToolTip
                  target="wind_direction_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "wind_direction_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2">
                  <Field name="weather_data.wind_direction">
                    {({ field }: FieldProps) => (
                      <React.Fragment>
                        <Select
                          name={field.name}
                          inputId="weather_data_wind_direction" // Safe HTML id
                          className="max-width-13"
                          options={directionOptions}
                          getOptionLabel={(e: any) => e.current_direction_name}
                          getOptionValue={(e: any) => e.id}
                          onBlur={handleBlur}
                          autoFocus={fieldVisibility.avgWaterSpeed.includes(
                            currentVesselReport && currentVesselReport?.reporting_event
                          ) ? false : true}
                          onChange={(e: any) => {
                            setFieldValue(field.name, e.id);
                            setFieldValue('weather_data.wind_direction_name', e.current_direction_name);
                          }}
                          menuPortalTarget={document.body}
                          styles={customStyle}
                          defaultValue={{
                            id: values?.weather_data?.wind_direction,
                            current_direction_name: values?.weather_data?.wind_direction_name,
                          }}
                        />
                        {errors?.weather_data?.wind_direction &&
                          touched?.weather_data?.wind_direction &&
                          env?.form_validation === true && !discardwarning && !alertBool && (
                            <ErrorTooltip
                              target="weather_data_wind_direction" // Matches inputId
                              message={errors.weather_data.wind_direction}
                              open={!!errors.weather_data.wind_direction}
                            />
                          )}
                      </React.Fragment>
                    )}
                  </Field>
                </div>
              </Col>
            )}
          {fieldVisibility.windSpeed.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="weather_data.wind_speed">
                  Wind speed
                </Label>
                <i className="bx bx-info-circle ml-2p" id="wind_speed_msg" />
                <ToolTip
                  target="wind_speed_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "wind_speed_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.wind_speed">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_wind_speed"
                        name={field.name}
                        value={values?.weather_data?.wind_speed}
                        onBlur={(e: any) => {
                          handleBlur(e);
                          if (env?.alerts && e.target.value > 25) {
                            if (e.target.value > 45) {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.DANGER);
                              setAlertType(AlertTypeConstant.WITH_REASON);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "high_weather_data_alert_msg", "Wind speed", field.value, `0 – 45`)
                              );
                              setFieldId('weather_data.wind_speed');
                              setAlertFieldLabel("Wind speed");
                              setAlertFieldValue(field.value);
                            } else {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.WARNING);
                              setAlertType(AlertTypeConstant.INFO_ONLY);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "normal_wind_speed_alert_msg", "Wind speed", field.value, `0 – 45`)
                              );
                              setAlertFieldLabel("Wind speed");
                              setAlertFieldValue(field.value);
                            }
                          }
                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          calculateBeaufortScale(e, setFieldValue);
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        autoComplete='off'
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">
                    knots
                  </div>
                </div>
                {errors &&
                  touched?.weather_data?.wind_speed &&
                  errors?.weather_data?.wind_speed &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_wind_speed"
                      message={errors?.weather_data?.wind_speed}
                      open={
                        errors && errors?.weather_data?.wind_speed
                          ? true
                          : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.beaufortScale.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="mb-0" for="beaufort_scale">
                  Beaufort scale
                  <i
                    className="bx bx-info-circle ml-2p"
                    id="beaufort_scale_msg"
                  />
                </Label>
                <ToolTip
                  target="beaufort_scale_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "beaufort_scale_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field
                    type="text"
                    className="form-control cursor-not-allowed max-width-7 text-right"
                    id="weather_data.beaufort_scale"
                    name="weather_data.beaufort_scale"
                    disabled
                  />
                  <div className="input-group-text round_border">bf</div>
                </div>
              </Col>
            )}
          {fieldVisibility.swellDirection.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <div className="mb-2">
                  <Label className="asteric mb-0" for="swell_direction">
                    Swell direction
                  </Label>
                  <i className="bx bx-info-circle ml-2p" id="swell_direction_msg" />
                  <ToolTip
                    target="swell_direction_msg"
                    message={`${TooltipMsg.Weather_Data.filter(
                      (item: any) => item.target === "swell_direction_msg"
                    ).map((tool: any) => {
                      return tool.message;
                    })}`}
                  />
                  <Field name="weather_data.swell_direction">
                    {({ field }: FieldProps) => (
                      <React.Fragment>
                        <Select
                          name={field?.name}
                          inputId={field?.name}
                          id="weather_data_swell_direction"
                          className="max-width-13"
                          options={directionOptions}
                          getOptionLabel={(e: any) =>
                            e?.current_direction_name
                          }
                          getOptionValue={(e: any) => e?.id}
                          onBlur={handleBlur}
                          onChange={(e: any) => {
                            setFieldValue(field?.name, e.id);
                            setFieldValue('weather_data.swell_direction_name', e.current_direction_name);
                          }}
                          menuPortalTarget={document.body}
                          styles={customStyle}
                          defaultValue={{
                            id: values?.weather_data?.swell_direction,
                            current_direction_name: values?.weather_data?.swell_direction_name,
                          }}
                        />
                        {errors &&
                          touched?.weather_data?.swell_direction &&
                          errors?.weather_data?.swell_direction &&
                          env?.form_validation === true && !discardwarning && !alertBool && (
                            <ErrorTooltip
                              target="weather_data_swell_direction"
                              message={errors?.weather_data?.swell_direction}
                              open={
                                errors &&
                                  errors?.weather_data?.swell_direction
                                  ? true
                                  : false
                              }
                            />
                          )}
                      </React.Fragment>
                    )}
                  </Field>
                </div>
              </Col>
            )}
          {fieldVisibility.swellHeight.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="swell_height">
                  Swell height
                </Label>
                <i className="bx bx-info-circle ml-2p" id="swell_height_msg" />
                <ToolTip
                  target="swell_height_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "swell_height_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.swell_height">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_swell_height"
                        name="weather_data.swell_height"
                        onBlur={(e: any) => {
                          handleBlur(e);
                          if (env?.alerts && (e.target.value < 0 || e.target.value > 3)) {
                            if (e.target.value > 8) {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.DANGER);
                              setAlertType(AlertTypeConstant.WITH_REASON);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "high_weather_data_alert_msg", "Swell height", field.value, `0 – 3`)
                              );
                              setFieldId('weather_data.swell_height');
                              setAlertFieldLabel("Swell height");
                              setAlertFieldValue(field.value);
                            } else {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.WARNING);
                              setAlertType(AlertTypeConstant.INFO_ONLY);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "normal_weather_data_alert_msg", "Swell height", field.value, `0 – 3`)
                              );
                              setAlertFieldLabel("Swell height");
                              setAlertFieldValue(field.value);
                            }
                          }
                        }}
                        onChange={(e: any) => {
                          handleChange(e)
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        defaultValue={values?.weather_data?.swell_height}
                        autoComplete={'off'}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">m</div>
                </div>
                {errors &&
                  touched?.weather_data?.swell_height &&
                  errors?.weather_data?.swell_height &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_swell_height"
                      message={errors?.weather_data?.swell_height}
                      open={!alertBool &&
                        errors && errors?.weather_data?.swell_height
                        ? true
                        : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.oceanCurrentSpeed.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="ocean_current_speed">
                  Ocean current's speed
                </Label>
                <i className="bx bx-info-circle ml-2p" id="ocean_current_speed_msg" />
                <ToolTip
                  target="ocean_current_speed_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) =>
                      item.target === "ocean_current_speed_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.ocean_current_speed">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_ocean_current_speed"
                        name="weather_data.ocean_current_speed"
                        onBlur={(e: any) => {
                          handleBlur(e);
                          if (env?.alerts && (e.target.value < 0 || e.target.value > 2.5)) {
                            if (e.target.value > 5) {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.DANGER);
                              setAlertType(AlertTypeConstant.WITH_REASON);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "high_weather_data_alert_msg", "Ocean current speed", field.value, `0 – 5`)
                              );
                              setFieldId('weather_data.ocean_current_speed');
                              setAlertFieldLabel("Ocean current speed");
                              setAlertFieldValue(field.value);
                            } else {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.WARNING);
                              setAlertType(AlertTypeConstant.INFO_ONLY);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "normal_weather_data_alert_msg", "Ocean current speed", field.value, `0 – 5`)
                              );
                              setAlertFieldLabel("Ocean current speed");
                              setAlertFieldValue(field.value);
                            }
                          }
                        }}
                        onChange={(e: any) => {
                          handleChange(e)
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        defaultValue={values?.weather_data?.ocean_current_speed}
                        autoComplete={values?.weather_data?.ocean_current_speed === null ? 'off' : 'no_complete'}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">
                    knots
                  </div>
                </div>
                {errors &&
                  touched?.weather_data?.ocean_current_speed &&
                  errors?.weather_data?.ocean_current_speed &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_ocean_current_speed"
                      message={errors?.weather_data?.ocean_current_speed}
                      open={
                        errors &&
                          errors?.weather_data?.ocean_current_speed
                          ? true
                          : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.oceanWaveHeight.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="ocean_wave_height">
                  Ocean wave height
                </Label>
                <i className="bx bx-info-circle ml-2p" id="ocean_wave_height_msg" />
                <ToolTip
                  target="ocean_wave_height_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "ocean_wave_height_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.ocean_wave_height">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_ocean_wave_height"
                        name={field.name}
                        onBlur={(e: any) => {
                          handleBlur(e);
                          if (env?.alerts && e.target.value > 3) {
                            if (e.target.value > 8) {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.DANGER);
                              setAlertType(AlertTypeConstant.WITH_REASON);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "high_weather_data_alert_msg", "Ocean wave height", field.value, `0 – 8`)
                              )
                              setFieldId('weather_data.ocean_wave_height');
                              setAlertFieldLabel("Ocean wave height");
                              setAlertFieldValue(field.value);
                            } else {
                              setAlertBool(true);
                              setAlertColourType(AlertColourTypeConstant.WARNING);
                              setAlertType(AlertTypeConstant.INFO_ONLY);
                              setAlertMessage(
                                getAlertMessage("WeatherData", "normal_weather_data_alert_msg", "Ocean wave height", field.value, `0 – 8`)
                              );
                              setAlertFieldLabel("Ocean wave height");
                              setAlertFieldValue(field.value);
                            }
                          }
                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          calculateSeaForce(e, setFieldValue);
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        defaultValue={values?.weather_data?.ocean_wave_height}
                        autoComplete={'off'}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">m</div>
                </div>
                {errors &&
                  touched?.weather_data?.ocean_wave_height &&
                  errors?.weather_data?.ocean_wave_height &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_ocean_wave_height"
                      message={errors?.weather_data?.ocean_wave_height}
                      open={!alertBool &&
                        errors && errors?.weather_data?.ocean_wave_height
                        ? true
                        : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.seaForce.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col md={3}>
                <Label className="mb-0" for="sea_force">
                  Sea force
                </Label>
                <div className="mb-2 input-group">
                  <Field
                    type="text"
                    className="form-control cursor-not-allowed max-width-7 text-right"
                    id="weather_data.sea_force"
                    name="weather_data.sea_force"
                    disabled
                  />
                  <div className="input-group-text round_border">dss</div>
                </div>
              </Col>
            )}
          {fieldVisibility.oceanCurrentDirection.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col md={3}>
                <div className="mb-2">
                  <Label
                    className="asteric mb-0"
                    for="ocean_current_direction"
                  >
                    Ocean current's direction
                  </Label>
                  <i className="bx bx-info-circle ml-2p" id="ocean_current_direction_msg" />
                  <ToolTip
                    target="ocean_current_direction_msg"
                    message={`${TooltipMsg.Weather_Data.filter(
                      (item: any) =>
                        item.target === "ocean_current_direction_msg"
                    ).map((tool: any) => {
                      return tool.message;
                    })}`}
                  />
                  <Field name="weather_data.ocean_current_direction">
                    {({ field }: FieldProps) => (
                      <React.Fragment>
                        <Select
                          name={field.name}
                          inputId={'ocean_current_direction'}
                          className="max-width-13"
                          options={directionOptions}
                          getOptionLabel={(e: any) =>
                            e.current_direction_name
                          }
                          getOptionValue={(e: any) => e.id}
                          onBlur={handleBlur}
                          onChange={(e: any) => {
                            setFieldValue(field.name, e.id);
                            setFieldValue('weather_data.ocean_current_direction_name', e.current_direction_name);
                          }}
                          menuPortalTarget={document.body}
                          styles={customStyle}
                          defaultValue={{
                            id: values?.weather_data?.ocean_current_direction,
                            current_direction_name: values?.weather_data?.ocean_current_direction_name,
                          }}
                        />
                        {errors &&
                          touched?.weather_data?.ocean_current_direction &&
                          errors?.weather_data?.ocean_current_direction &&
                          env?.form_validation === true && !discardwarning && !discardwarning && !alertBool && (
                            <ErrorTooltip
                              target="ocean_current_direction"
                              message={
                                errors?.weather_data?.ocean_current_direction
                              }
                              open={
                                errors &&
                                  errors?.weather_data?.ocean_current_direction
                                  ? true
                                  : false
                              }
                            />
                          )}
                      </React.Fragment>
                    )}
                  </Field>
                </div>
              </Col>
            )}
          {fieldVisibility.badWeather.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label
                  className="asteric mb-0"
                  for="period_in_bad_weather"
                >
                  Period in bad weather
                </Label>
                <i
                  className="bx bx-info-circle ml-2p"
                  id="period_in_bad_weather_msg"
                />
                <ToolTip
                  target="period_in_bad_weather_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) =>
                      item.target === "period_in_bad_weather_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.period_in_bad_weather">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_period_in_bad_weather"
                        name="weather_data.period_in_bad_weather"
                        onBlur={handleBlur}
                        onChange={(e: any) => {
                          handleChange(e)
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        defaultValue={
                          values?.weather_data?.period_in_bad_weather
                        }
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">hrs</div>
                </div>
                {errors &&
                  touched?.weather_data?.period_in_bad_weather &&
                  errors?.weather_data?.period_in_bad_weather &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_period_in_bad_weather"
                      message={errors?.weather_data?.period_in_bad_weather}
                      open={!alertBool &&
                        errors &&
                        errors?.weather_data?.period_in_bad_weather
                        ? true
                        : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.airTemperature.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="air_temperature">
                  Air temperature
                </Label>
                <i
                  className="bx bx-info-circle ml-2p"
                  id="air_temperature_msg"
                />
                <ToolTip
                  target="air_temperature_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "air_temperature_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.air_temperature">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_air_temperature"
                        name="weather_data.air_temperature"
                        onBlur={(e: any) => {
                          handleBlur(e);
                          if (env?.alerts && (e.target.value < -25 || e.target.value > 50)) {
                            setAlertBool(true);
                            setAlertColourType(AlertColourTypeConstant.WARNING);
                            setAlertType(AlertTypeConstant.INFO_ONLY);
                            setAlertMessage(
                              getAlertMessage("WeatherData", "normal_weather_data_alert_msg", "Air temperature", field.value, `-25 – 50`)
                            );
                            setAlertFieldLabel("Air temperature");
                            setAlertFieldValue(field.value);
                          }
                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        value={field.value ?? ""}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">
                    <sup>o</sup>C
                  </div>
                </div>
                {errors &&
                  touched?.weather_data?.air_temperature &&
                  errors?.weather_data?.air_temperature &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_air_temperature"
                      message={errors?.weather_data?.air_temperature}
                      open={!alertBool && errors && errors?.weather_data?.air_temperature ? true : false}
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.seaTemperature.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="sea_temperature">
                  Sea temperature
                </Label>
                <i
                  className="bx bx-info-circle ml-2p"
                  id="sea_temperature_msg"
                />
                <ToolTip
                  target="sea_temperature_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "sea_temperature_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.sea_temperature">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_sea_temperature"
                        onBlur={(e: any) => {
                          handleBlur(e);
                          const value = parseFloat(e.target.value);
                          if (env?.alerts && (value < -15 || value > 50)) {
                            setAlertBool(true);
                            setAlertColourType(AlertColourTypeConstant.WARNING);
                            setAlertType(AlertTypeConstant.INFO_ONLY);
                            setAlertMessage(
                              getAlertMessage("WeatherData", "normal_weather_data_alert_msg", "Sea temperature", value, `-15 – 50`)
                            );
                            setAlertFieldLabel("Sea temperature");
                            setAlertFieldValue(field.value);
                          }
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(e);
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        value={field.value ?? ""}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">
                    <sup>o</sup>C
                  </div>
                </div>
                {errors &&
                  touched?.weather_data?.sea_temperature &&
                  errors?.weather_data?.sea_temperature &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_sea_temperature"
                      message={errors?.weather_data?.sea_temperature}
                      open={!alertBool && errors && errors?.weather_data?.sea_temperature ? true : false}
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.gyroCourse.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="gyro_course">
                  Gyro course
                </Label>
                <i
                  className="bx bx-info-circle ml-2p"
                  id="gyro_course_msg"
                />
                <ToolTip
                  target="gyro_course_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) => item.target === "gyro_course_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.gyro_course">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_gyro_course"
                        onBlur={handleBlur}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(e);
                          handleNoSpaceInputChange(e, form, field.name);
                        }}
                        value={field.value ?? ""}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">
                    deg
                  </div>
                </div>
                {errors &&
                  touched?.weather_data?.gyro_course &&
                  errors?.weather_data?.gyro_course &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_gyro_course"
                      message={errors?.weather_data?.gyro_course}
                      open={
                        errors && errors?.weather_data?.gyro_course
                          ? true
                          : false
                      }
                    />
                  )}
              </Col>
            )}
          {fieldVisibility.barometricPressure.includes(
            currentVesselReport && currentVesselReport?.reporting_event
          ) && (
              <Col lg={3}>
                <Label className="asteric mb-0" for="barometric_pressure">
                  Barometric pressure
                </Label>
                <i className="bx bx-info-circle ml-2p" id="barometric_pressure_msg" />
                <ToolTip
                  target="barometric_pressure_msg"
                  message={`${TooltipMsg.Weather_Data.filter(
                    (item: any) =>
                      item.target === "barometric_pressure_msg"
                  ).map((tool: any) => {
                    return tool.message;
                  })}`}
                />
                <div className="mb-2 input-group">
                  <Field name="weather_data.barometric_pressure">
                    {({ field, form }: FieldProps) => (
                      <Input
                        onFocus={(e) => e.target.select()}
                        {...field}
                        type="text"
                        className="form-control max-width-7 text-right"
                        id="weather_data_barometric_pressure"
                        name="weather_data.barometric_pressure"
                        value={field.value ?? ""}
                        onChange={(e) => handleNoSpaceInputChange(e, form, field.name)}
                        onBlur={(e: any) => {
                          handleBlur(e);
                          handleNoSpaceInputChange(e, form, field.name);
                          const value = parseFloat(e.target.value);
                          const min = 990;
                          const max = 1040;
                          if (env?.alerts && (value < min || value > max)) {
                            setAlertBool(true);
                            setAlertColourType(AlertColourTypeConstant.INFO);
                            setAlertType(AlertTypeConstant.INFO_ONLY);
                            setAlertMessage(
                              getAlertMessage("WeatherData", "weather_data_barometric_pressure_alert_msg", "Barometric pressure", value, `${min}–${max}`)
                            );
                            setAlertFieldLabel("Barometric pressure");
                            setAlertFieldValue(field.value);
                          }
                        }}
                      />
                    )}
                  </Field>
                  <div className="input-group-text round_border">mbar</div>
                </div>
                {errors &&
                  touched?.weather_data?.barometric_pressure &&
                  errors?.weather_data?.barometric_pressure &&
                  env?.form_validation === true && !discardwarning && !alertBool && (
                    <ErrorTooltip
                      target="weather_data_barometric_pressure"
                      message={errors?.weather_data?.barometric_pressure}
                      open={!alertBool && errors && errors?.weather_data?.barometric_pressure ? true : false}
                    />
                  )}
              </Col>
            )}
        </Row>
        {fieldVisibility.generalAvgSpeed.includes(currentVesselReport?.reporting_event)
          && (AddGeneralAvgSpeed) && (
            <React.Fragment>
              <hr />
              <Row className="ele_row1 mt-2">
                <h4> Additional Information</h4>
                <Col md={3}>
                  <Label className="asteric mb-0" for="additional_info.general_avg_speed">
                    General Average Speed
                  </Label>
                  <div className="mb-2 input-group">
                    <Field
                      type="text"
                      className="form-control disabled text-right max-width-7"
                      id="additional_info_general_avg_speed"
                      name="additional_info.general_avg_speed"
                      defaultValue={
                        values?.additional_info?.general_avg_speed
                      }
                    />
                    <div className="input-group-text round_border">knots</div>
                  </div>

                  {errors?.additional_info?.general_avg_speed &&
                    env?.form_validation === true && !discardwarning && !alertBool && (
                      <ErrorTooltip
                        target="additional_info_general_avg_speed"
                        message={errors.additional_info.general_avg_speed}
                        open={true}
                      />
                    )}
                </Col>
              </Row>
            </React.Fragment>
          )}
      </CardBody>
      <CardFooter className="p-2 py-3">
        <Row className="d-flex align-items-center flex-row-reverse">
          <Col lg={10}>
            <div className="d-flex flex-wrap gap-3 justify-content-end ">
              {/* {editReportBool && (
                <Button
                  type="reset"
                  color="danger"
                  className="btn_size_cstm"
                  onClick={() => {
                    setEditValues({
                      ...editValues,
                      deck_officer: {
                        ...editValues?.deck_officer,
                        weather_data: editInitalValues?.deck_officer?.weather_data,
                      }
                    });
                    setRefreshKey(refreshKey + 1);
                  }}
                >
                  Reset
                </Button>
              )} */}
              <Button
                type={editReportBool ? "button" : "submit"}
                color="primary"
                className="btn_size_cstm"
                disabled={isSubmitting || editIsSubmitting}
                onClick={async () => {
                  const validationErrors = await validateForm();
                  Object.keys(values.weather_data || {}).forEach((key) => {
                    setFieldTouched(`weather_data.${key}`, true, false);
                  });
                  if (editReportBool && Object.keys(validationErrors).length === 0) {
                    await saveEditForm(editSubmit, toggleTab, 0, setPreviousDeckTabIndex);
                    setRefreshKey((prev: number) => prev + 1);
                  }
                }}
              >
                {(isSubmitting || editIsSubmitting) && (
                  <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                )}
                Next <i className="bx bx-chevron-right ms-1" />
              </Button>
            </div>
          </Col>
          <Col lg={2}>
            <Button
              type="button"
              color="primary"
              className={`btn_size_cstm ${!editReportBool && "disabled"}`}
              onClick={() => {
                setErrors({});
                if (editReportBool) {
                  setDeckActiveTabBool(false);
                  toggle(activeEditTab - 1);
                }
                setErrorMessage(null);
              }}
            >
              <i className="bx bx-chevron-left me-1" /> Previous
            </Button>
          </Col>
          {alertBool && (
            <AlertPopup
              state={alertBool}
              setState={setAlertBool}
              alertMessage={alertMessage}
              setAlertMessage={setAlertMessage}
              AlertColourType={alertColourType}
              setAlertColourType={setAlertColourType}
              alertType={alertType}
              setAlertType={setAlertType}
              formTitle="Weather Data"
              generatedFor={null}
              fieldId={fieldId}
              fieldLabel={fieldLable}
              fieldValue={fieldValue}
            />
          )}
        </Row>
      </CardFooter>
      <FormValuesDebug
        values={[
          errors,
          values,
          initialValues,
        ]}
      />
    </Form>
  )
}

export default WeatherDataStructure